import React from "react";
import { useParams, useSearchParams } from "react-router-dom";

const apps: Record<string, string> = {
  fietsvergoeding: "e8da4646-bbb7-4d33-9dd2-8af94b748efb",
  schuldvordering: "2d2313b8-ed17-49d1-bd4e-e38a96c2bded",
  settings: "d4fe7ad0-0784-4fdf-b8b1-063758be6d48",
};

const PowerApp: React.FC = () => {
  const { appName } = useParams<{ appName: string }>();
  const [searchParams, _] = useSearchParams();

  const portraitDimensions = {
    width: "384px",
    height: "681.6px",
  };

  const landscapeDimensions = {
    height: "385px",
    width: "685px",
  };

  const src = `https://apps.powerapps.com/play/${appName}?tenantId=d44f2493-c06b-41d8-9ad8-4e4826a79c1f&source=iframe`;
  return (
    <div className="flex justify-center">
      <div
        style={
          searchParams.get("landscape") === "true"
            ? landscapeDimensions
            : portraitDimensions
        }
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            backgroundColor: "white",
            position: "relative",
          }}
          className="w-full h-full bg-white"
        >
          <iframe
            className="bg-white"
            src={src}
            style={{
              backgroundColor: "white",
            }}
            allow="fullscreen"
            width={"100%"}
            height={"100%"}
            title="Embedded Power App"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default PowerApp;
